import React from 'react';
import './deviceFrame.css';

const DeviceFrame = ({ children }) => {
  return (
    <div className="iphone-frame">
      <div className="screen">{children}</div>
    </div>
  );
};

export default DeviceFrame;
